import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Stream from 'flarum/utils/Stream';

import CaptchaComponent from '../CaptchaComponent';
import UserManageUserEditModal from "./UserManageUserEditModal";
import showAlert from '../../common/util/showAlert';
import addDaysToDate from '../../common/util/addDaysToDate';

export default class UserApplyInviteCodeModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.from = this.attrs.from || "userManage";
    this.userInfoData = this.attrs.userInfoData;
    this.userData = this.userInfoData.u2diUserData();
    this.editMode = this.attrs.editMode;
    this.settings = this.attrs.settings;
    this.u2di_zsxm = this.userInfoData.attribute("zsxm");
    this.u2di_userType = this.userInfoData.attribute("userType");
    this.u2di_extendCode = Stream("");
    this.u2di_isValid = false;
    this.u2di_inviteCodeValidated = null;

    this.startDate = Stream("");
    this.validDurationText = Stream("");
    this.validDuration = Stream(0);
    this.u2diCaptcha = Stream("");
  }

  onOptionReady(){
    if(this.from==="indexPage"){
      $(".Modal-close").hide();
    }
  }

  onremove(){
    if(this.from==="userManage"){
      const userInfoData = this.userInfoData;
      const settings = this.settings;
      const editMode = this.editMode;

      setTimeout(function(){
        app.modal.show(UserManageUserEditModal,{userInfoData,settings,editMode});
      },100);
    }
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-u2di.forum.title-apply-invite-code');
  }

  content() {

    const currentDate = this.userInfoData.currentDate();
    const expireDays = this.userInfoData.expireDays()+this.validDuration();
    const expireDate = dayjs(addDaysToDate(currentDate,expireDays)).format('YYYY年M月D日');

    return (
      <div className="Modal-body" style="padding-top: 0px;">
        <div className="Form" style="text-align:center">
          <div className="Form-group">
            <div className="u2diUserSubmitCategoryItems" style="text-align: left;">
              <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
                {app.translator.trans('ziven-u2di.forum.signup-field-account')}
              </div>
              <div oncreate={this.onOptionReady.bind(this)} className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                <div style="display: flex;align-items: flex-end;">
                  {this.u2di_zsxm}（{app.translator.trans('ziven-u2di.forum.user-type-'+this.u2di_userType)}）
                </div>
              </div>
            </div>

            <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
              <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
                {app.translator.trans('ziven-u2di.forum.signup-field-extend-code')}
              </div>
              <div style="display: flex;column-gap: 10px;" className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                <input disabled={this.loading || this.u2di_inviteCodeValidated===true} className="FormControl" bidi={this.u2di_extendCode} />
                {Button.component({
                    disabled: this.loading || this.u2di_inviteCodeValidated===true,
                    className: 'Button Button--primary',
                    onclick: (e) => {
                      this.validateExtendCode(e);
                    }
                  },
                  app.translator.trans('ziven-u2di.forum.button-check-extend-code')
                )}
              </div>
            </div>

            {this.u2di_inviteCodeValidated===null && (
              <div style="padding-top: 5px;text-align: left; " className="u2diUserSubmitCategoryItems">
                <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
                  {app.translator.trans('ziven-u2di.forum.captcha-validation')}
                </div>
                <div style="display: flex;" className="u2diUserSubmitCategoryItemOptions">
                  <input style="width: 102px;" id="u2diCaptcha" disabled={this.loading} required className="FormControl u2diUserSubmitCategoryItemInput" type="input" maxlength="4" bidi={this.u2diCaptcha} />
                  <CaptchaComponent />
                </div>
              </div>
            )}

            {this.u2di_inviteCodeValidated===true && (
              <div>
                <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
                  <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
                  </div>
                  <div style="font-size:12px" className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                    <div style="color:#70B603">{app.translator.trans('ziven-u2di.forum.extend-code-validate-success',{duration:this.validDurationText()})}</div>
                    <div style="padding-top:10px">{app.translator.trans('ziven-u2di.forum.extend-code-vaild-until',{date:expireDate})}</div>
                  </div>
                </div>

                <div style="padding-top:10px">
                  {Button.component({
                      style:'width: 100px;',
                      className: 'Button Button--primary',
                      disabled: this.loading,
                      onclick: () => {
                        this.confirmExtend();
                      }
                    },
                    app.translator.trans('ziven-u2di.lib.confirm-extent')
                  )}
                  {Button.component({
                      style:'margin-left: 10px;width: 100px;',
                      className: 'Button U2DiButton--gray',
                      disabled: this.loading,
                      onclick: () => {
                        this.hide();
                      }
                    },
                    app.translator.trans('ziven-u2di.lib.cancel')
                  )}
                </div>
              </div>
            )}

            {this.u2di_inviteCodeValidated===false && (
              <div>
                <div className="u2diUserSubmitCategoryItems" style="text-align: left;padding-top: 10px;">
                  <div className="u2diUserSubmitCategoryItemName u2diSignUpItemName">
                  </div>
                  <div style="font-size:12px" className="u2diUserSubmitCategoryItemOptions u2diSignUpItemOptions">
                      <div style="color:#D9001B">{app.translator.trans('ziven-u2di.forum.error-invalid-extend-code')}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  confirmExtend(){

    this.loading = true;
    const extendCode = (this.u2di_extendCode()).trim();

    this.userInfoData.save({
      extendCode:extendCode
    })
    .then(() => {
        showAlert(app.translator.trans('ziven-u2di.forum.success-save'),'success');
        this.hide();
        m.redraw();
      },
      (response) => {
        this.loading = false;
      }
    );
  }

  validateExtendCode(){
    const inviteCode = (this.u2di_extendCode()).trim();

    if(inviteCode){
      this.loading = true;

      app.store
        .find("u2diInviteCode",{inviteCode:inviteCode,u2diCaptcha:this.u2diCaptcha()})
        .catch(() => {
          this.loading = false;
          $(".u2diCaptcheImage").click();
          m.redraw();
        })
        .then((result) => {
          this.loading = false;
          const validateData = result[0];

          if(validateData){
            const realName = validateData.realName();
            const validDuration = validateData.validDuration();
            const currentDate = validateData.currentDate();
            const validDurationText = "duration-"+validDuration;
            
            this.validDuration(validDuration);
            this.validDurationText(app.translator.trans('ziven-u2di.lib.'+validDurationText));
            this.startDate(currentDate);
            this.u2di_inviteCodeValidated = true;
          }else{
            this.u2di_inviteCodeValidated = false;
          }

          m.redraw();
      });
    }
  }
}
